import {
  login,
  verifyRegisterEmail,
  registerCompany,
  getCode,
  resetPwdCode,
  resetPwd,
  getResetPwd
} from '@/api/common'

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ name: username.trim(), pwd: password.trim() }).then(response => {
        // debugger
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /* 验证注册邮箱验证码 */
  verifyRegisterEmail({ commit }, data) {
    const { checkCode, email } = data
    return new Promise((resolve, reject) => {
      verifyRegisterEmail({ checkCode: checkCode && checkCode.trim(), email: email.trim() }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /* 注册公司 */
  registerCompany({ commit }, data) {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        if (data[key] && typeof data[key] === 'string') {
          data[key] = data[key].trim()
        }
      }
    }
    return new Promise((resolve, reject) => {
      registerCompany(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /* 发送注册邮箱验证码 */
  getCode({ commit }, data) {
    const { email } = data
    return new Promise((resolve, reject) => {
      getCode({ channel: 1, email: email && email.trim() }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetPwdCode({ commit }, data) {
    const { checkCode, email } = data
    return new Promise((resolve, reject) => {
      resetPwdCode({ checkCode: checkCode && checkCode.trim(), email: email.trim() }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetPwd({ commit }, data) {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        if (data[key] && typeof data[key] === 'string') {
          data[key] = data[key].trim()
        }
      }
    }
    return new Promise((resolve, reject) => {
      resetPwd(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getResetPwd({ commit }, data) {
    const { email } = data
    return new Promise((resolve, reject) => {
      getResetPwd({ channel: 1, email: email.trim() }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  actions
}

